import { render, staticRenderFns } from "./Rollenverwaltung.vue?vue&type=template&id=39303740&scoped=true&"
import script from "./Rollenverwaltung.vue?vue&type=script&lang=js&"
export * from "./Rollenverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./Rollenverwaltung.vue?vue&type=style&index=0&id=39303740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39303740",
  null
  
)

export default component.exports